module.exports = __webpack_public_path__ + "static/media/contactIcon.392fe804.svg";